// extracted by mini-css-extract-plugin
module.exports = {"dialog":"EnterResultPopup_dialog_275Wo","actions":"EnterResultPopup_actions_21Vyf"};